module.exports = __webpack_public_path__ + "8da12525d694dfb4af74c1e08073323d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/td-icons.svg
 ** module id = 28
 ** module chunks = 0
 **/